__turbopack_context__.v({
  "cBtn": "style-module-scss-module__JcZITW__cBtn",
  "cBtn____danger": "style-module-scss-module__JcZITW__cBtn____danger",
  "cBtn____green": "style-module-scss-module__JcZITW__cBtn____green",
  "cBtn____isSelected": "style-module-scss-module__JcZITW__cBtn____isSelected",
  "cBtn__text": "style-module-scss-module__JcZITW__cBtn__text",
});
